/**
 * Text out of a photo — a screenshot of an iPhone Note, not sheet music.
 * Tesseract does fine on that: it's typed, high-contrast, single-column text,
 * the easy end of what OCR is asked to do.
 *
 * Loaded lazily. Tesseract's wasm core is a few megabytes — nobody who never
 * imports a photo should pay for it in the main bundle.
 *
 * Every path below is explicit and same-origin (public/tesseract/), not
 * Tesseract's own jsDelivr-CDN default. The CSP here is `default-src 'self'`
 * with no wildcard — a cross-origin worker or wasm fetch would fail silently
 * in production, the kind of gap that only shows up the first time someone
 * actually uses the feature.
 */
export async function ocrImage(file, onProgress) {
  const { createWorker } = await import('tesseract.js')
  const worker = await createWorker('eng', 1, {
    workerPath: '/tesseract/worker.min.js',
    corePath: '/tesseract/core',
    langPath: '/tesseract/lang',
    logger: (m) => {
      if (onProgress && m.status === 'recognizing text') onProgress(m.progress)
    },
  })
  try {
    const { data } = await worker.recognize(file)
    return data.text
  } finally {
    await worker.terminate()
  }
}
